module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeDropdownTabs.length > 0 || _vm.authenticated) ? _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "role": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n        Witaj"), (_vm.authenticated) ? _c('span', [_vm._v(", " + _vm._s(_vm.username))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_vm._l((_vm.activeDropdownTabs), function(tab) {
    return _c('a', {
      key: tab.name,
      staticClass: "dropdown-item",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.emitTab(tab)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.name) + "\n        ")])
  }), _vm._v(" "), (_vm.activeDropdownTabs.length > 0 && _vm.authenticated) ? _c('div', {
    staticClass: "dropdown-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.authorizedApps.length > 1) ? _c('div', [_vm._l((_vm.authorizedApps), function(app) {
    return _c('a', {
      staticClass: "dropdown-item",
      class: {
        'current-link': app.name === _vm.currentApp
      },
      attrs: {
        "href": app.href
      }
    }, [(app.name === _vm.currentApp) ? _c('span', [_vm._v("▹")]) : _vm._e(), _vm._v(" " + _vm._s(app.displayName) + "\n            ")])
  }), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "dropdown-divider"
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Wyloguj się")]) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1195b346!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/NavbarDropdown.vue
// module id = 1083
// module chunks = 0